var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetAccessKeys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57143 0C5 0 2.14286 2.85714 2.14286 6.42857H0L2.78571 9.21428L2.85714 9.28571L5.71429 6.42857H3.57143C3.57143 3.64286 5.78571 1.42857 8.57143 1.42857C11.3571 1.42857 13.5714 3.64286 13.5714 6.42857C13.5714 9.21428 11.3571 11.4286 8.57143 11.4286C7.21429 11.4286 5.92857 10.8571 5.07143 9.92857L4.07143 10.9286C5.21429 12.1429 6.78571 12.8571 8.57143 12.8571C12.1429 12.8571 15 10 15 6.42857C15 2.85714 12.1429 0 8.57143 0ZM7.85714 8.57143H9.28571V10H7.85714V8.57143ZM7.85714 2.85714H9.28571V7.14286H7.85714V2.85714Z",
    fill: "#EB4343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetAccessKeys);
export default __webpack_public_path__ + "static/media/reset_access_keys.7ca28dadcf8a3315b3a70691d09c9094.svg";
export { ForwardRef as ReactComponent };